import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import NewFourHome from "../pages/new4/page";
import NewFourPrivacyPage from "../pages/new4/privacy";
import NewFourTermsPage from "../pages/new4/terms";
import NewFourCookiesPage from "../pages/new4/cookies";
import NewFourAboutPage from "../pages/new4/about";
import NewFourContactPage from "../pages/new4/contact";
import NewFourGeoPage from "../pages/new4/geo";
import NewFourDataLayerPage from "../pages/new4/data-layer";
import NewFourContentEnginePage from "../pages/new4/content-engine";
import NewFourCroPage from "../pages/new4/cro";
import NewFourLeadScoringPage from "../pages/new4/lead-scoring";
import NewFourWhitepaperPage from "../pages/new4/whitepaper";
import NewFourAuditPage from "../pages/new4/audit";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <NewFourHome />,
  },
  {
    path: "/privacy",
    element: <NewFourPrivacyPage />,
  },
  {
    path: "/terms",
    element: <NewFourTermsPage />,
  },
  {
    path: "/cookies",
    element: <NewFourCookiesPage />,
  },
  {
    path: "/about",
    element: <NewFourAboutPage />,
  },
  {
    path: "/contact",
    element: <NewFourContactPage />,
  },
  {
    path: "/geo",
    element: <NewFourGeoPage />,
  },
  {
    path: "/data-layer",
    element: <NewFourDataLayerPage />,
  },
  {
    path: "/content-engine",
    element: <NewFourContentEnginePage />,
  },
  {
    path: "/cro",
    element: <NewFourCroPage />,
  },
  {
    path: "/lead-scoring",
    element: <NewFourLeadScoringPage />,
  },
  {
    path: "/whitepaper",
    element: <NewFourWhitepaperPage />,
  },
  {
    path: "/audit",
    element: <NewFourAuditPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
